import { GetOrderResponseResult } from '@/coreInfrastructureModule/axios/generated/orderManage';
import { CalendarOrder } from '../domains/entities/CalendarOrder';
import { CalendarOrderFactory } from '../domains/factories/CalendarOrderFactory';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { OrderStatus } from '@/coreDomainsModule/entities/arrival';
import { convertUnixTimeToIDate } from '@/corePagesModule/BaseTableContent/utils/dateFormat';

/**
 *　発注Repositoryの型をカレンダー上の発注情報に変換する
 */
export class CalendarOrderAdapter {
  /**
   * レスポンスをカレンダー上の発注情報に変換する
   * @param response - 発注情報
   */
  public static adapt = (response: GetOrderResponseResult): CalendarOrder[] => {
    const calendarOrder: CalendarOrder[] = [];
    response.data?.forEach((order) => {
      if (order.orderStatus === undefined || Object.keys(OrderStatus).includes(order.orderStatus) === false)
        console.error(`OrderStatus is invalid. orderStatus: ${order.orderStatus}`);
      const crossDate = order.estimatedTimeOfArrival
        ? DateService.convertDateToIDate(new Date(order.estimatedTimeOfArrival))
        : { year: 0, month: 0, day: 0 };
      const createDate = order.createdOrderDate ? DateService.convertUnixTimeToDate(order.createdOrderDate / 1000) : new Date();

      calendarOrder.push(
        CalendarOrderFactory.create({
          parentBusinessId: order.aggregateBusinessId,
          unit: order.unit,
          businessName: order.businessName,
          arrivalId: order.orderId,
          amount: order.orderAmount,
          crossDate: crossDate,
          status: order.orderStatus as OrderStatus,
          year: createDate.getFullYear(),
          month: createDate.getMonth() + 1,
          day: createDate.getDate(),
          warehouse: order.warehouse,
          supplierName: order.supplierName,
          package: order.package.toString(),
          businessNumber: order.businessNumber,
          outputDate: order.outputDate ? convertUnixTimeToIDate(new Date(order.outputDate).getTime()) : undefined,
          number: order.orderNumber,
          isOutOfStockExpected: order.isOutOfStockExpected,
          updateAt: order.updateAt,
          // NOTE: 発注グループが1件しかこない想定
          orderGroupId: order.orderGroupList[0]?.orderGroupId,
        })
      );
    });
    return calendarOrder;
  };
}
